import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.merchant.sections.associatedPerson.deleteConfirmationModal';

export const LABELS = makeLabels(
  {
    MODAL_TITLE: ['modalTitle', 'Delete Beneficial Owner'],
    CONTENT_TITLE: ['contentTitle', 'Are you sure?'],
    CONTENT_MESSAGE: ['contentMessage', 'You are removing the associated person from the organization.'],
    CANCEL: ['cancel', 'Cancel'],
    CONFIRM: ['confirm', 'Confirm'],
  },
  NAMESPACE,
);

export default LABELS;
